import React from 'react';
import { connect } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';

import { FormikCheckBox, FormikInput } from '../../components';

const OtherRequestTypeForm = props => {
  const {
    onHide,
    submitVariant,
    errors,
    touched,
    action,
    isSubmitting
  } = props;
  const btnMessage = action === 'new' ? 'Crear' : 'Guardar';

  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Field name="otherRequestType[name]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  abbr
                  label="Nombre"
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={12}>
            <Field name="otherRequestType[isActive]">
              {({ field }) => <FormikCheckBox {...field} field={field} label="Activo" />}
            </Field>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn" type="submit" variant={submitVariant} disabled={isSubmitting} onClick={onHide}>
          {btnMessage}
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { id, isActive, name } = props.otherRequestType;

  return {
    otherRequestType: {
      id,
      isActive,
      name
    }
  };
};

const validationSchema = Yup.object().shape({
  otherRequestType: Yup.object().shape({
    isActive: Yup.boolean(),
    name: Yup.string()
      .required('Debes ingresar un nombre')
      .max(100, 'Deben ser menos que 100 caracteres')
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(connect()(OtherRequestTypeForm));
